module.exports = "build/assets/mobileHeroNoise.1810b75c.png";